"use strict";
exports.__esModule = true;
exports.gregorianMonths = exports.jalaliMonths = void 0;
exports.jalaliMonths = [
    { name: 'فروردین', value: 1 },
    { name: 'اردیبهشت', value: 2 },
    { name: 'خرداد', value: 3 },
    { name: 'تیر', value: 4 },
    { name: 'مرداد', value: 5 },
    { name: 'شهریور', value: 6 },
    { name: 'مهر', value: 7 },
    { name: 'آبان', value: 8 },
    { name: 'آذر', value: 9 },
    { name: 'دی', value: 10 },
    { name: 'بهمن', value: 11 },
    { name: 'اسفند', value: 12 },
];
exports.gregorianMonths = [
    { name: 'Jan', value: 1 },
    { name: 'Feb', value: 2 },
    { name: 'Mar', value: 3 },
    { name: 'Apr', value: 4 },
    { name: 'May', value: 5 },
    { name: 'Jun', value: 6 },
    { name: 'Jul', value: 7 },
    { name: 'Aug', value: 8 },
    { name: 'Sep', value: 9 },
    { name: 'Oct', value: 10 },
    { name: 'Nov', value: 11 },
    { name: 'Dec', value: 12 },
];
//# sourceMappingURL=months.js.map